import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL ?? '',
  realm: process.env.REACT_APP_KEYCLOAK_DEFAULT_REALM ?? 'myrealm',
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? 'myclient',
});

export default keycloak;
